export const SET_SELECTED_RESOURCE = 'dashboard/SET_SELECTED_RESOURCE';

export const setSelectedResource = (resourceType, resourceId) => ({
    type: SET_SELECTED_RESOURCE,
    payload: {
        resourceType,
        resourceId
    }
});
